import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Layout from './route/layout';
import { fetchHeaderMenu } from './redux/features/toolsSlice';
import { useDispatch, useSelector } from 'react-redux';
import useLanguagePercistant from './hooks/useLanguagePercistant';
import useLanguageTranslate from './hooks/useLanguageTranslate';
import { useEffect } from 'react';
import { fetchDashboardData, selectDashboardWhole } from './redux/features/dashboardSlice';
// import { fetchHomeData, fetchHomePlansData } from './redux/features/homeSlice';
import { fetchPlanHeader } from './redux/features/plansSlice';
import { fetchTermsData } from './redux/features/termsSlice';
import { fetchPrizeRulesData } from './redux/features/prizeRulesSlice';

function App() {
    useLanguagePercistant();
    const dispatch = useDispatch();

    useEffect(() => {
      // Track page view
      // ReactGA.pageview(window.location.pathname + window.location.search);
      dispatch(fetchHeaderMenu());
      dispatch(fetchDashboardData());
      dispatch(fetchPlanHeader());
      dispatch(fetchTermsData());
      dispatch(fetchPrizeRulesData())

    }, []);
    const translate = useLanguageTranslate();
  return (
    <div className={`App ${translate("english", "arabic")}`}>
      <Layout />
    </div>
  );
}

export default App;
